export default __webpack_public_path__ + "static/media/groupingSelected.8fcb93fc.svg";